import { useRef } from 'react'

import { ShotlistsService } from '@/services/shotlist.service'

import { STATUS } from '@/constants/common'
import { IShotlist } from '@/types/shotlist.interface'

export const useTaskWatch = () => {
	const timerRef = useRef<ReturnType<typeof setTimeout>>()

	const clearWatch = () => {
		if (timerRef.current) {
			clearTimeout(timerRef.current)
			timerRef.current = undefined
		}
	}

	const watchTask = async (
		taskId: string,
		onUpdate?: (shotlist: IShotlist) => void,
		onFinished?: (shotlist: IShotlist) => void
	) => {
		if (!taskId) return

		clearWatch()

		try {
			const shotlist = await ShotlistsService.getShotlist(taskId)

			const isFinishedWithResult =
				shotlist.status === STATUS.FINISHED && shotlist.original

			const isFailed = shotlist.status === STATUS.FAILED

			onUpdate?.(shotlist as unknown as IShotlist)

			if (isFinishedWithResult || isFailed) {
				clearWatch()
				onFinished?.(shotlist as unknown as IShotlist)
			} else {
				timerRef.current = setTimeout(() => {
					watchTask(taskId, onUpdate, onFinished)
				}, 3000)
			}
		} catch (error) {
			console.log('Error watching task', error)
			clearWatch()
		}
	}

	return { watchTask, clearWatch }
}
